<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Листа дефинисаних рокова пројекта') }}
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span><i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за приказ дефинисаних рокова пројекта') }}
        </span>
      </div>

    </div>
    <!-- <div class="page-part"
      *ngIf="auth.isAuthorized('C68C7E32-A85D-4D7D-8E42-9B312C0CD723') &&
      state === viewState.Edit &&
    (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)">
      <div class="page-actions">
        <button class="btn btn-success" (click)="showCreateModal()"><i class="fa fa-plus mr-1"></i>
          {{ translationManager.getTranslation('Додати нови рок') }}</button>
      </div>
    </div> -->

    <div class="app-table-panel" app-table>

      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <!-- <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по задатку')" order
                  order-entity="ТaskName">
                  {{ translationManager.getTranslation('Задатак') }}
                </a> -->
                {{ translationManager.getTranslation('Задатак') }}
              </th>

              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по року за извршење')" order
                  order-entity="DeadlineForCompletion">
                  {{ translationManager.getTranslation('Рок за извршење') }}
                </a> -->
                {{ translationManager.getTranslation('Рок за извршење') }}
              </th>

<!--              <th>-->
<!--                &lt;!&ndash; <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по приказ добављачу')" order-->
<!--                  order-entity="DisplaysToSuppliers">-->
<!--                  {{ translationManager.getTranslation('Приказ добављачу') }}-->
<!--                </a> &ndash;&gt;-->
<!--                {{ translationManager.getTranslation('Приказ добављачу') }}-->
<!--              </th>-->
              <th style="width: 140px" class="right" *ngIf="state === viewState.Edit">
                {{ translationManager.getTranslation('Акције') }}
              </th>
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of items">
              <td>{{item.taskName}}</td>
              <td>
                <span [ngStyle]="{'color': item.deadlineForCompletion===null ? 'red' : '' }">
                  {{item.deadlineForCompletion===null? translationManager.getTranslation('Поље је обавезно за унос'):item.deadlineForCompletion | date:'dd.MM.YYYY'}}
                </span>
              </td>
<!--              <td>{{translationManager.getTranslation(item.displaysToSuppliers) }}</td>-->
              <td style="width: 140px" class="right" *ngIf="state === viewState.Edit">
                <div class="table-actions">
                  <!-- <a *ngIf="auth.isAuthorized('C68C7E32-A85D-4D7D-8E42-9B312C0CD723')
                    && (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)"
                    [routerLink]="['./opn-projectdeadline-list-edit', item.id]" [title]="translationManager.getTranslation('Измена')">
                    <i class="far fa-file-alt"></i>
                </a> -->

                  <!-- <a *ngIf="auth.isAuthorized('C68C7E32-A85D-4D7D-8E42-9B312C0CD723')
                  && (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)"
                    (click)="showEditModal(item)" href="javascript:;"
                    [title]="translationManager.getTranslation('Измена')">
                    <i class="far fa-file-alt"></i>
                  </a>
                  <a *ngIf="auth.isAuthorized('88E63E47-C55A-4433-89F8-B7D5D7EF5AB0')
                      && (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)
                      && (item.taskId >0)" href="javascript:;" (click)="showDeleteModalFor(item.id)" class="red"
                    [title]="translationManager.getTranslation('Брисање')">
                    <i class="far fa-trash-alt"></i>
                  </a> -->
                </div>
              </td>
            </tr>

          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
      <!-- <div class="app-table-pagination">
        <div>
          <div pagination>
            <span>{{ translationManager.getTranslation('Страна') }}</span>
            <select pagination-pages>
              <option>1</option>
            </select>
            <span>{{ translationManager.getTranslation('од') }}</span>
            <span pagination-pages-count>-</span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                pagination-first-page>
                <i class="fas fa-angle-double-left"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page>
                <i class="fas fa-angle-left"></i>
              </a>
            </span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page>
                <i class="fas fa-angle-right"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page>
                <i class="fas fa-angle-double-right"></i>
              </a>
            </span>
            <span>{{ translationManager.getTranslation('Број редова за приказ') }}</span>
            <select pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="app-table-pagination-sizes">
          <div>
            <span>{{ translationManager.getTranslation('Укупан број слогова') }}</span>
            <span pagination-total-count>-</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>


<app-modal [show]="showDeleteModal" [title]="translationManager.getTranslation('Брисање дефинисаног рока пројекта?')">
  <div class="app-modal-content">
    {{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете дефинисани рок пројекта?') }}
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<opn-projectdeadline-list #opnProjectDeadlineListComponent></opn-projectdeadline-list>
